import { Component, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { TableHeaderCheckboxToggleEvent } from "primeng/table";
import { ArtistProduct } from "src/app/models/artistproduct.model";
import { ConsignedProductsRequest, PlatformSyncResult, SyncProductsResponse } from "src/app/Services/artistproducts.service";
import { AuthConfig, AuthService, ResponseObject } from "src/app/Services/auth.service";
import { ConsignmentService, GalleryConsignmentProduct } from "src/app/Services/consignment.service";
import { ShopifyOAuthToken, ShopifyService, ShopifyStoreAccount } from "src/app/Services/shopify-service/shopify.service";
import { SquareUpOAuthTokken, SquareupPosService } from "src/app/Services/squareup-pos.service.ts/squareup-pos.service";
import { StoreDetail, WoocomerceService, WoocommerceCredentials } from "src/app/Services/woocomerce-service/woocomerce.service";
import { ConsignmentCommentRequest, SquareSpaceAccountInfo, SyncAcceptedProduct } from "../../artist-components/view-consignment/view-consignment.component";
import { ConnectSquareupPosAccountComponent } from "../../connect-squareup-pos-account/connect-squareup-pos-account.component";
import { WixComponent } from "../../connect-with-wix/wix.component";
import { ConnectWoocommerceAccountComponent } from "../connect-woocommerce-account/connect-woocommerce-account.component";
import { ShopifyAccount } from "../shopify-account/shopify-account.component";
import { AllPlatformCurrencyExchangeRate, WixService } from "src/app/Services/Wix-Service/wix.service";
import { NotificationTypes } from "src/app/app.enums";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { StripePlans } from "src/app/models/stripe.model";
import { ImageUtils } from "src/app/shared/utils/image-utils";
import { CurrencyExchangeService } from "../consignment-product-selection/platforms-currency-settings-dialogs/CurrencyExchangeService/CurrencyExchange.service";
import { SubscriptionRulesService } from "src/app/Services/subscription-rules.service";
import { SquareSpaceService } from "src/app/Services/square-space/square-space.service";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: "product-sync",
    templateUrl: "./product-sync.component.html",
    styleUrls: ["./product-sync.component.css"],
    standalone: false
})

export class ProductSyncComponent implements OnInit {
  @ViewChild(WixComponent, { static: false }) wixComponent: WixComponent | undefined;
  @ViewChild(ConnectWoocommerceAccountComponent, { static: false }) woocommerceComponent: ConnectWoocommerceAccountComponent | undefined;
  @ViewChild(ConnectSquareupPosAccountComponent, { static: false }) squareComponent: ConnectSquareupPosAccountComponent | undefined;
  @ViewChild(ShopifyAccount, { static: false }) shopifyComponent: ShopifyAccount | undefined;
  public galleryProducts: GalleryConsignmentProduct[] = [];
  public selectedProduct: GalleryConsignmentProduct[] = [];
  public currentArtwork!: GalleryConsignmentProduct;
  public consignmentProducts: ArtistProduct[] = [];
  public stripePlans: StripePlans[] = [];
  public selectedConsignmnetPoduct: SyncAcceptedProduct = {} as SyncAcceptedProduct;
  public selectedPlatform: string[] = [];
  public acceptedConsignmentProductIds: string[] = [];
  public galleryProductsLoaded: boolean = false;
  public isProfileDialogVisible: boolean = false;
  public isFreePlanUser: boolean = true;
  public checkAccountExitsOnWix: boolean = false
  public isShopifyConnectionDailogVisible: boolean = false;
  public isAddWoocommerceAccountDailogVisible: boolean = false;
  public showCommentDialog: boolean = false;
  public showProductSyncronizationDialog: boolean = false;
  public displayCurrencyDialog: boolean = false;
  public isManualRate: boolean = false;
  public allSelected: boolean = false;
  public isArtworkDetailDailogVisible: boolean = false;
  public isStripeDisplayPlansDialogVisible: boolean = false;
  public artistId: string | null = null;
  public authConfig!: AuthConfig;
  public shopifyAccount: ShopifyOAuthToken = {} as ShopifyOAuthToken;
  public squareUpAccount: SquareUpOAuthTokken = {} as SquareUpOAuthTokken;
  public wooCommerceAccount: WoocommerceCredentials = {} as WoocommerceCredentials;
  public selectedGalleryProductsInventory: GalleryConsignmentProduct[] = [];
  public platforms!: AllPlatformCurrencyExchangeRate;
  public selectedWoocommerceStore: string = '';
  public isWooCommercePlatform: boolean = false;
  public selectedWoocommerceStores: string[] = [];
  platformsToSend: { plateform: string; accountId: string }[] = [];
  public isLoading: boolean = true;
  public allResponsesSuccessful: boolean = false;
  public selectedPlatformDailaog: boolean = false;
  public wooCommerceAccountList: StoreDetail[] = [];
  public isSquarePos!: boolean;
  public isShopify!: boolean;
  public isWoocommerce!: boolean;
  public isWix!: boolean;
  public selectAllState: { [key: string]: boolean } = { 'Square': false, 'Shopify': false, 'WooCommerce': false, 'Wix': false, 'SquareSpace': false };
  checkAccountExistOnSquareSpace: boolean = false;
  isSquareSpaceStoreDialogVisible: boolean = false;
  public squareSpaceStoreDetails: any[] = [];
  public isSquareSpacePlatform: boolean = false;
  public squareSpaceStorePage: any[] = [];
  public siteId: string = '';
  public pageId: string = '';

  constructor(
    private route: ActivatedRoute,
    private ngxSpinnerService: NgxSpinnerService,
    private consignmentService: ConsignmentService,
    private authService: AuthService,
    private shopifyService: ShopifyService,
    private wixService: WixService,
    private squareService: SquareupPosService,
    private wooCommerceService: WoocomerceService,
    private notificationsService: NotificationsService,
    private CurrencyExchangeService: CurrencyExchangeService,
    private subscriptionRulesService: SubscriptionRulesService,
    private squareSpaceService: SquareSpaceService,
    private Router: Router,
    private transloco: TranslocoService,
  ) {
    this.selectedConsignmnetPoduct.squareSpaceAccountInfo = {} as SquareSpaceAccountInfo;
  }
  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    this.subscriptionRulesService.CanAcceptMoreConsignmentProducts().subscribe(
      (response) => {
        this.ishavelimt = response.IsHaveLimit;
        this.limit = response.Limit;
        console.log('Fetched consignment:', response);
      },
      (error) => {
        console.error('Error fetching consignment settings:', error);
      }
    );
    this.route.paramMap.subscribe(params => {
      if (params.has('artistId')) {
        this.artistId = params.get('artistId')!;
        this.getGalleryConsignmentProducts(this.artistId);
      } else {
        this.getGalleryConsignmentProducts();
      }
    });
    this.isFreePlanUser = this.authService.isFreePlanUser();
    this.isSquarePos = this.authService.IsSquarePOS();
    this.isShopify = this.authService.IsShopify();
    this.isWoocommerce = this.authService.IsWoocommerce();
    this.isWix = this.authService.IsWix();
  }

  public getGalleryConsignmentProducts(artistId: string | null = null, filters: ConsignedProductsRequest = {}) {
    this.galleryProductsLoaded = false;
    this.ngxSpinnerService.show();
    this.consignmentService.getGalleryConsignmentProducts(artistId, filters).subscribe((galleryProducts: GalleryConsignmentProduct[]) => {

      this.galleryProducts = galleryProducts.filter(product => product.IsProductAcceptedByGallery && !product.IsProductSold);
      this.galleryProducts = this.galleryProducts
        .filter(product => product.IsProductAcceptedByGallery && !product.IsProductSold)
        .map(product => {
          product.Product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(
            product.Product.ProductImgUrl || 'assets/images/No-Image.png'
          );
          return product;
        });
      this.galleryProductsLoaded = true;

      console.log('Filtered galleryProducts', this.galleryProducts);
      this.ngxSpinnerService.hide();
    }, (error) => {
      console.error(error); this.ngxSpinnerService.hide();
      this.galleryProductsLoaded = true;
    });
  }

  public showProfileDialog(): void {
    this.isProfileDialogVisible = true;
  }

  public onConnectSquareupPosAccount(): void {
    this.Router.navigate(['/connect-squareup-pos-account']);
  }

  public onShowShopifyConnectionDailog() {
    this.isShopifyConnectionDailogVisible = true
  }

  public onCloseShopifyConnectionDailog($event: boolean) {
    this.isShopifyConnectionDailogVisible = $event
  }

  public onShowWoocommerceAccountDailog() {
    this.isAddWoocommerceAccountDailogVisible = true
  }

  public onCloseWoocommerceAccountDailog($event: boolean) {
    this.isAddWoocommerceAccountDailogVisible = $event
  }

  public resetSelectedData(): void {
    this.acceptedConsignmentProductIds = [];
    this.selectedPlatform = [];
    // this.getConsignmentProducts(this.consignmentId);
    this.consignmentProducts.forEach(product => {
      product.IsSyncToSquarePos = false;
      product.IsSyncToShopify = false;
      product.IsSyncToWooCommerce = false;
      product.IsSyncToWix = false;
      product.IsSyncToSquareSpace = false;

    });
    this.selectAllState = {
      Square: false,
      Shopify: false,
      WooCommerce: false,
      Wix: false,
      SquareSpace: false

    };
  }


  public onCurrencyDialogHide(): void {
    console.log('Currency dialog hidden - resetting selections');
    // Reset all platform selections
    this.selectedPlatform = [];
    this.platformsToSend = [];
    // Reset all store selections
    this.selectedWoocommerceStore = '';
    this.selectedShopifyStore = '';
    this.siteId = '';
    this.pageId = '';

    // Reset all product sync flags
    this.consignmentProducts.forEach(product => {
      product.IsSyncToSquarePos = false;
      product.IsSyncToShopify = false;
      product.IsSyncToWooCommerce = false;
      product.IsSyncToWix = false;
      product.IsSyncToSquareSpace = false;
    });

    // Reset select all checkboxes
    this.selectAllState = {
      Square: false,
      Shopify: false,
      WooCommerce: false,
      Wix: false,
      SquareSpace: false
    };

    // If you have any other sync request data to reset
    if (this.selectedConsignmnetPoduct.productSyncRequests) {
      this.selectedConsignmnetPoduct.productSyncRequests = [];
    }

    // Reset SquareSpace account info if needed
    this.selectedConsignmnetPoduct.squareSpaceAccountInfo = {
      id: '',
      pageId: ''
    };

    console.log('All selections have been reset after currency dialog close');
  }


  public acceptConsignment(isManual: boolean): void {
    this.showCommentDialog = false;
    this.isManualRate = isManual;
    console.log(isManual)
    this.acceptConsignmentProducts(null);
  }


  public getSelectedStoreDetails(platform: string): { name: string, image: string } | null {
    switch (platform) {
      case 'WooCommerce':
        if (this.selectedWoocommerceStore) {
          const store = this.wooCommerceAccountList.find(s => s.Id === this.selectedWoocommerceStore);
          return store ? {
            name: store.StoreName || 'WooCommerce Store',
            image: 'assets/images/woocommerace-log.png'
          } : null;
        }
        break;

      case 'Shopify':
        if (this.selectedShopifyStore) {
          const store = this.shopifyAccountList.find(s => s.Id === this.selectedShopifyStore);
          return store ? {
            name: store.StoreName || 'Shopify Store',
            image: 'assets/images/shopify-log.png'
          } : null;
        }
        break;

      case 'SquareSpace':
        if (this.siteId) {
          const store = this.squareSpaceStoreDetails.find(s => s.Id === this.siteId);
          return store ? {
            name: store.SiteInfo?.title || 'SquareSpace Store',
            image: 'assets/images/squarespace.svg'
          } : null;
        }
        break;

      case 'SquarePOS':
        return {
          name: 'Square POS',
          image: 'assets/images/square-log.png'
        };

      case 'Wix':
        return {
          name: 'Wix',
          image: 'assets/images/wix-logo.png'
        };
    }
    return null;
  }

  private resetAllSelections(): void {
    // Reset product selections
    this.selectedProduct = [];
    this.acceptedConsignmentProductIds = [];
    this.selectedGalleryProductsInventory = [];

    // Reset platform selections
    this.selectedPlatform = [];
    this.platformsToSend = [];

    // Reset store selections
    this.selectedWoocommerceStore = '';
    this.selectedShopifyStore = '';
    this.siteId = '';
    this.pageId = '';

    // Reset select all checkboxes
    this.selectAllState = {
      Square: false,
      Shopify: false,
      WooCommerce: false,
      Wix: false,
      SquareSpace: false
    };

    // Reset product sync flags
    this.consignmentProducts.forEach(product => {
      product.IsSyncToSquarePos = false;
      product.IsSyncToShopify = false;
      product.IsSyncToWooCommerce = false;
      product.IsSyncToWix = false;
      product.IsSyncToSquareSpace = false;
    });

    // Reset sync requests
    if (this.selectedConsignmnetPoduct.productSyncRequests) {
      this.selectedConsignmnetPoduct.productSyncRequests = [];
    }

    // Reset SquareSpace account info
    this.selectedConsignmnetPoduct.squareSpaceAccountInfo = {
      id: '',
      pageId: ''
    };

    console.log('All selections have been reset');
  }
  // Add these properties to your component class
  public showSyncResultsDialog = false;
  syncResults = {
    overallSuccess: false,
    overallMessage: '',
    platforms: [] as {
      name: string;
      success: boolean;
      hasWarnings: boolean;
      message: string;
      newSyncedCount: number;
      existingSyncedCount: number;
    }[]
  };

  // GALLERY IMPLEMENTATION - FIXED VERSION
  public acceptConsignmentProducts($event: MouseEvent | null): void {
    console.log('Starting acceptConsignmentProducts...');

    const selectedProductsForSync = this.selectedConsignmnetPoduct.productSyncRequests?.filter(p =>
      p.IsSyncToShopify || p.IsSyncToSquareUp || p.IsSyncToWooCommerce || p.IsSyncToWix || p.IsSyncToSquareSpace
    ) || [];

    this.selectedConsignmnetPoduct.productSyncRequests = selectedProductsForSync;
    this.selectedConsignmnetPoduct.isUserAddManullyRates = this.isManualRate;

    // Set account IDs
    const anyProductSyncingToWoo = selectedProductsForSync.some(p => p.IsSyncToWooCommerce);
    const anyProductSyncingToShopify = selectedProductsForSync.some(p => p.IsSyncToShopify);
    const anyProductSyncingToSquareSpace = selectedProductsForSync.some(p => p.IsSyncToSquareSpace);

    if (anyProductSyncingToWoo) {
      this.selectedConsignmnetPoduct.woocommerceAccountId = this.selectedWoocommerceStore;
    }
    if (anyProductSyncingToShopify) {
      this.selectedConsignmnetPoduct.shopifyAccountId = this.selectedShopifyStore;
    }
    if (anyProductSyncingToSquareSpace) {
      if (!this.selectedConsignmnetPoduct.squareSpaceAccountInfo) {
        this.selectedConsignmnetPoduct.squareSpaceAccountInfo = {
          id: '',
          pageId: ''
        };
      }
      this.selectedConsignmnetPoduct.squareSpaceAccountInfo.pageId = this.pageId;
      this.selectedConsignmnetPoduct.squareSpaceAccountInfo.id = this.siteId;
    }

    this.ngxSpinnerService.show();

    this.consignmentService.syncAcceptedConsignmentProducts(this.selectedConsignmnetPoduct).subscribe({
      next: (response: SyncProductsResponse) => {
        this.ngxSpinnerService.hide();

        this.prepareSyncResults(response);
        this.showSyncResultsDialog = true;
        this.getGalleryConsignmentProducts();

        const notificationType = response.ResponseObject.Success
          ? NotificationTypes.Success
          : NotificationTypes.Error;
        this.notificationsService.showNotification(
          response.ResponseObject.Success ? this.transloco.translate('productSync.success') : this.transloco.translate('productSync.error'),
          response.ResponseObject.ResponseMessage,
          notificationType
        );

        // Close all dialogs
        this.displayCurrencyDialog = false;
        this.showProductSyncronizationDialog = false;
        this.selectedPlatformDailaog = false;

        // Reset all selections after successful API call
        this.resetAllSelections();
      },
      error: (error) => {
        this.ngxSpinnerService.hide();
        console.error('🚨 API Call Failed:', error);
        this.notificationsService.showNotification(
          this.transloco.translate('productSync.error'),
          this.transloco.translate('productSync.failedToSync'),
          NotificationTypes.Error
        );

        // Reset selections even on error
        this.resetAllSelections();
      }
    });
  }

  private prepareSyncResults(response: SyncProductsResponse): void {
    // Set overall status
    this.syncResults = {
      overallSuccess: response.ResponseObject.Success,
      overallMessage: response.ResponseObject.ResponseMessage,
      platforms: []
    };

    // Process Shopify results if exists
    if (response.Shopify) {
      this.syncResults.platforms.push(this.processPlatformResponse('Shopify', response.Shopify));
    }

    // Process WooCommerce results if exists
    if (response.WooCommerce) {
      this.syncResults.platforms.push(this.processPlatformResponse('WooCommerce', response.WooCommerce));
    }

    // Process SquareSpace results if exists
    if (response.SquareSpace) {
      this.syncResults.platforms.push(this.processPlatformResponse('SquareSpace', response.SquareSpace));
    }
  }

  private processPlatformResponse(platformName: string, result: PlatformSyncResult): any {
    const newSyncedCount = result.SyncedProducts?.length || 0;
    const existingSyncedCount = result.AlreadySyncedProducts?.length || 0;

    const success = result.ResponseObject?.Success ?? false;
    const hasWarnings = (!success && existingSyncedCount > 0) ||
      (success && existingSyncedCount > 0 && newSyncedCount > 0);

    let message = result.ResponseObject?.ResponseMessage;
    if (!message) {
      if (success) {
        message = newSyncedCount > 0
          ? existingSyncedCount > 0
            ? this.transloco.translate('productSync.someSyncedSomeUpToDate')
            : this.transloco.translate('productSync.productsSynchronized')
          : this.transloco.translate('productSync.allAlreadySynced');
      } else {
        message = hasWarnings
          ? this.transloco.translate('productSync.someCouldNotSync')
          : this.transloco.translate('productSync.failedToSyncProducts');
      }
    }

    return {
      name: platformName,
      success,
      hasWarnings,
      message,
      newSyncedCount,
      existingSyncedCount
    };
  }


  public onShowArtworkDetailDailog(artworkDetail: GalleryConsignmentProduct) {
    this.currentArtwork = artworkDetail
    this.isArtworkDetailDailogVisible = true
  }
  public oncloseArtworkDetailDailog() {
    this.isArtworkDetailDailogVisible = false
  }
  public onUpgradePlan() {
    this.isStripeDisplayPlansDialogVisible = true
  }
  public onCloseStripePaymentDailog($event: boolean) {
    this.isStripeDisplayPlansDialogVisible = $event;
  }
  public selectInventory(product: GalleryConsignmentProduct) {
    const selectedInventory = this.selectedGalleryProductsInventory;
    const currentInventory = this.galleryProducts;
    if (!selectedInventory.some((item) => item.Product.Id === product.Product.Id)) {
      // Move the product to selectedInventory
      selectedInventory.push(product);
      // Add the product's ID to selectedProducts array
      this.selectedProduct.push(product);
      console.log('Selected Product IDs:', this.selectedProduct);
      if (product.IsProductAcceptedByGallery) {
        if (!this.acceptedConsignmentProductIds.includes(product.Product.Id)) {
          this.acceptedConsignmentProductIds.push(product.Product.Id); // Add to list if selected
        } else {
          this.acceptedConsignmentProductIds = this.acceptedConsignmentProductIds.filter(id => id !== product.Product.Id); // Remove from list if unselected
        }
      }
      // Remove the selected item from currentInventory
      const index = currentInventory.findIndex((item) => item.Product.Id === product.Product.Id);
      if (index !== -1) {
        currentInventory.splice(index, 1);
      }
    }

  }

  public moveToCurrentInventory(product: GalleryConsignmentProduct) {
    const selectedInventory = this.selectedGalleryProductsInventory;
    const currentInventory = this.galleryProducts;
    // Find the index of the item in the selectedInventory array
    const currentIndex = selectedInventory.findIndex((item) => item.Product.Id === product.Product.Id);
    // If the item is found, remove it from selectedInventory and add it to currentInventory
    if (currentIndex !== -1) {
      const removedItem = selectedInventory.splice(currentIndex, 1)[0];
      // Remove the product's ID from selectedProducts array
      const idIndex = this.selectedProduct.findIndex((product) => product.Product.Id === removedItem.Product.Id);
      if (idIndex !== -1) {
        this.selectedProduct.splice(idIndex, 1);
      }
      currentInventory.push(removedItem);
      //   this.isProductSelected = selectedInventory.length > 0;
      console.log('Selected Product IDs:', this.selectedProduct);
    }
  }

  public connectWithWixAccount(): void {
    this.Router.navigate(['/connect-with-wix-account']);
  }

  public HasAccountOnShopify() {
    this.shopifyService.hasAccountOnShopify().subscribe(
      (accountExists: ShopifyOAuthToken) => {
        this.shopifyAccount = accountExists;
      }, (error) => { console.error(error); });
  }
  public hasAccountOnWix(): void {
    this.wixService.hasAccountOnWix().subscribe((res) => {
      if (res.Success) {
        const accountExists = res.Success;
        console.log('Wix account exists:', accountExists);
        this.checkAccountExitsOnWix = accountExists
      }
    }, (error) => { console.error(error); });
  }

  public hasAccountOnSquareSpace(): void {
    this.squareSpaceService.hasAccountOnSquareSpace().subscribe(
      (res) => {
        if (res?.Success) {
          console.log('SquareSpace account exists:', res.Success);
          this.checkAccountExistOnSquareSpace = true;
        } else {
          console.log('No SquareSpace account found.');
          this.checkAccountExistOnSquareSpace = false;
        }
      },
      (error) => {
        console.error('Error while checking SquareSpace account:', error);
        this.checkAccountExistOnSquareSpace = false; // set to false on error
      }
    );
  }


  public HasAccountOnSquareUp() {
    this.squareService.hasAccountOnSquareUp().subscribe(
      (accountExists: SquareUpOAuthTokken) => {
        this.squareUpAccount = accountExists;
      }, (error) => { console.error(error); });
  }

  public HasAccountOnWooCommerce() {
    this.wooCommerceService.hasAccountOnWooCommerce().subscribe(
      (accountExists: WoocommerceCredentials) => {
        this.wooCommerceAccount = accountExists;
      }, (error) => { console.error(error); });
  }


  public onSyncProductPlatform() {
    this.showProductSyncronizationDialog = true
    this.HasAccountOnShopify();
    this.HasAccountOnSquareUp();
    this.HasAccountOnWooCommerce();
    this.hasAccountOnWix();
    this.hasAccountOnSquareSpace();
    this.consignmentProducts = this.consignmentProducts.filter(product => this.acceptedConsignmentProductIds.includes(product.Id));
  }
  public onHeaderCheckboxToggle(event: any) {
    console.log(event.target.checked)
    this.allSelected = event.target.checked;
    console.log(this.allSelected)
    if (this.allSelected) {
      this.selectedProduct = [...this.galleryProducts];
      console.log(this.selectedProduct)
      const allSelected = this.consignmentProducts.every(product => product.IsAccepted);
      this.consignmentProducts.forEach(product => {
        product.IsAccepted = !allSelected;
        if (product.IsAccepted && !this.acceptedConsignmentProductIds.includes(product.Id)) {
          this.acceptedConsignmentProductIds.push(product.Id); // Add to list if selected
        } else if (!product.IsAccepted) {
          this.acceptedConsignmentProductIds = this.acceptedConsignmentProductIds.filter(id => id !== product.Id); // Remove from list if unselected
        }
      });
    } else {
      this.selectedProduct = [];
      console.log(this.selectedProduct)
    }
  }

  public toggleSelection(rowData: GalleryConsignmentProduct): void {
    console.log('Row Data:', rowData.Product.Id);
    console.log(this.selectedProduct)
    const existingIndex = this.selectedProduct.findIndex(product => product.Product.Id === rowData.Product.Id);
    console.log('Existing Index:', existingIndex)
    if (existingIndex !== -1) {
      this.selectedProduct.splice(existingIndex, 1);
      console.log('Removed:', this.selectedProduct);
    } else {
      this.selectedProduct.push(rowData);
      console.log('Added:', this.selectedProduct);
    }
    if (rowData.IsProductAcceptedByGallery) {
      if (!this.acceptedConsignmentProductIds.includes(rowData.Product.Id)) {
        this.acceptedConsignmentProductIds.push(rowData.Product.Id);
        console.log('Added for sync', this.acceptedConsignmentProductIds)
      }
    } else {
      const index = this.acceptedConsignmentProductIds.indexOf(rowData.Product.Id);
      if (index !== -1) {
        this.acceptedConsignmentProductIds.splice(index, 1);
      }
    }
    this.allSelected = this.selectedProduct.length === this.galleryProducts.length;
    console.log('All selected:', this.allSelected)
  }

  get isAnyPlatformSelected(): boolean {
    return Object.values(this.selectAllState).some(value => value === true);
  }

  public isSelected(rowData: GalleryConsignmentProduct): boolean {
    return this.selectedProduct.findIndex(product => product.Product.Id === rowData.Product.Id) > -1;
  }

  public onDisableCheckBox(platform: 'Shopify' | 'WooCommerce' | 'Square' | 'Wix' | 'SquareSpace', event: any): boolean {
    const platformConditions: { Shopify: boolean; WooCommerce: boolean; Square: boolean; Wix: boolean; SquareSpace: boolean; } = {
      Shopify: !this.shopifyAccount || (!this.shopifyAccount && this.isFreePlanUser),
      WooCommerce: !this.wooCommerceAccount || (!this.wooCommerceAccount && this.isFreePlanUser),
      Square: !this.squareUpAccount || (!this.squareUpAccount && this.isFreePlanUser),
      Wix: !this.checkAccountExitsOnWix || (!this.checkAccountExitsOnWix && this.isFreePlanUser),
      SquareSpace: !this.checkAccountExistOnSquareSpace || (!this.checkAccountExistOnSquareSpace && this.isFreePlanUser),
    };
    const isCheckboxDisabled = platformConditions[platform];
    if (isCheckboxDisabled) {
      event.preventDefault();
      this.showProfileDialog();
    }
    return isCheckboxDisabled;
  }

  public fetchExchangeRates(): void {
    this.isLoading = true;
    this.CurrencyExchangeService.fetchAllPlatformCurrencyWithExchangeRate(this.platformsToSend)
      .subscribe({
        next: (response: AllPlatformCurrencyExchangeRate) => {
          console.log('Exchange Rate Response:', response);
          // Ensure SquareSpace data is properly formatted
          if (response?.IntegratedPlateformCurrencyExchangeRate) {
            response.IntegratedPlateformCurrencyExchangeRate = response.IntegratedPlateformCurrencyExchangeRate.map(platform => {
              if (platform.Plateform === 'SquareSpace' && this.squareSpaceStoreDetails.length > 0) {
                // Add currency info from SquareSpace store details
                platform.TargetCurrencySymbol = this.squareSpaceStoreDetails[0]?.SiteInfo?.currency || 'AUD';
              }
              return platform;
            });
          }
          this.platforms = response;
          this.isLoading = false;
        },
        error: (error) => {
          const errorMessage = error?.error?.ResponseObject?.ResponseMessage || 'Failed to fetch exchange rates. Please try again later.';
          console.error(errorMessage);
          this.isLoading = false;
        }
      });
  }
  public prepareAndFetchExchangeRates(platforms: string[]): void {
    const payload = platforms.map(platform => {
      let accountId = '';

      if (platform === 'WooCommerce') {
        accountId = this.getWooCommerceAccountId();
      }
      else if (platform === 'Shopify') {
        accountId = this.getShopifyAccountId();
      }
      else if (platform === 'SquareSpace') {
        // Send the minimal required identification
        accountId = this.getSquareSpaceAccountId(); // Just send the pageId as that's what's needed
      }

      return {
        plateform: platform === 'Square' ? 'squarepos' : platform.toLowerCase(),
        accountId: accountId
      };
    });

    console.log('Calling exchange rate API with payload:', payload);
    this.platformsToSend = payload;
  }


  public toggleSelectAll(platform: 'Square' | 'Shopify' | 'WooCommerce' | 'Wix' | 'SquareSpace', event: any): void {
    console.log(`Toggling Select All for platform: ${platform}, Checked: ${event.target.checked}`);

    // Free Plan check
    if (this.isFreePlanUser) {
      if ((this.ishavelimt && this.acceptedConsignmentProductIds.length >= this.limit) || !this.ishavelimt) {
        this.displayUpgreadAccountDialog = true;
        console.log('Product sync limit reached for Free Plan user');

        // Uncheck the checkbox manually
        event.preventDefault();
        event.target.checked = false;
        this.selectAllState[platform] = false;

        return;
      }
    }

    // Account connection check
    const isDisabled = this.onDisableCheckBox(platform, event);
    if (isDisabled) {
      this.selectAllState[platform] = false;
      console.log(`Checkbox is disabled for ${platform}`);
      return;
    }

    const isChecked = event.target.checked;
    this.selectAllState[platform] = isChecked;

    // Handle WooCommerce and Shopify store selection
    if (isChecked && (platform === 'WooCommerce' || platform === 'Shopify' || platform === 'SquareSpace')) {
      this.acceptConsignmentProductsDialog(platform, isChecked);

      return; // Wait for store selection before proceeding
    }

    // For other platforms or when unchecking
    this.handlePlatformSelection(platform, isChecked);
  }

  private handlePlatformSelection(platform: 'Square' | 'Shopify' | 'WooCommerce' | 'Wix' | 'SquareSpace', isChecked: boolean): void {
    this.consignmentProducts.forEach(product => {
      switch (platform) {
        case 'Square': product.IsSyncToSquarePos = isChecked; break;
        case 'Shopify': product.IsSyncToShopify = isChecked; break;
        case 'WooCommerce': product.IsSyncToWooCommerce = isChecked; break;
        case 'Wix': product.IsSyncToWix = isChecked; break;
        case 'SquareSpace': product.IsSyncToSquareSpace = isChecked; break;
      }
    });

    if (!this.selectedConsignmnetPoduct.productSyncRequests) {
      this.selectedConsignmnetPoduct.productSyncRequests = [];
    }

    this.acceptedConsignmentProductIds.forEach(productId => {
      const existingRequestIndex = this.selectedConsignmnetPoduct.productSyncRequests.findIndex(request =>
        request.ConsignmentProductId === productId
      );

      if (existingRequestIndex !== -1) {
        switch (platform) {
          case 'Square': this.selectedConsignmnetPoduct.productSyncRequests[existingRequestIndex].IsSyncToSquareUp = isChecked; break;
          case 'Shopify': this.selectedConsignmnetPoduct.productSyncRequests[existingRequestIndex].IsSyncToShopify = isChecked; break;
          case 'WooCommerce': this.selectedConsignmnetPoduct.productSyncRequests[existingRequestIndex].IsSyncToWooCommerce = isChecked; break;
          case 'Wix': this.selectedConsignmnetPoduct.productSyncRequests[existingRequestIndex].IsSyncToWix = isChecked; break;
          case 'SquareSpace': this.selectedConsignmnetPoduct.productSyncRequests[existingRequestIndex].IsSyncToSquareSpace = isChecked; break;
        }
      } else {
        this.selectedConsignmnetPoduct.productSyncRequests?.push({
          ConsignmentProductId: productId,
          IsSyncToShopify: platform === 'Shopify' ? isChecked : false,
          IsSyncToSquareUp: platform === 'Square' ? isChecked : false,
          IsSyncToWooCommerce: platform === 'WooCommerce' ? isChecked : false,
          IsSyncToWix: platform === 'Wix' ? isChecked : false,
          IsSyncToSquareSpace: platform === 'SquareSpace' ? isChecked : false,
        });
      }
    });

    let value: string = platform === 'Square' ? 'SquarePOS' : platform;
    const selectedPlatformIndex = this.selectedPlatform.findIndex(x => x === value);

    if (isChecked && selectedPlatformIndex === -1) {
      this.selectedPlatform.push(value);
      console.log(`${platform} added to selectedPlatform.`);
    } else if (!isChecked && selectedPlatformIndex !== -1) {
      this.selectedPlatform.splice(selectedPlatformIndex, 1);
      console.log(`${platform} removed from selectedPlatform.`);

      if (platform === 'WooCommerce') {
        this.resetWooCommerceSelection();
      }
      if (platform === 'Shopify') {
        this.resetShopifySelection();
      }
      if (platform === 'SquareSpace') {
        this.resetSquareSpaceSelection()
      }
    }

    console.log("Final selectedPlatform:", this.selectedPlatform);
    console.log("Final selectAllState:", this.selectAllState);
  }

  public checkIsAccountIsAllowedForSync(platform: string): boolean {
    switch (platform) {
      case "Square": if (!this.squareUpAccount) { this.selectAllState[platform] = false; return false; } break;
      case "Shopify": if (!this.shopifyAccount) { this.selectAllState[platform] = false; return false; } break;
      case "WooCommerce": if (!this.wooCommerceAccount) { this.selectAllState[platform] = false; return false; } break;
      case "Wix": if (!this.checkAccountExitsOnWix) { this.selectAllState[platform] = false; return false; } break;
      default: console.warn(`Unknown platform: ${platform}`); return false;
    }
    return true;
  }

  private getWooCommerceAccountId(): string {
    const selectedStore = this.wooCommerceAccountList.find(store => store.Id === this.selectedWoocommerceStore);
    return selectedStore?.Id || '';
  }

  private getShopifyAccountId(): string {
    const selectedStore = this.shopifyAccountList.find(store => store.Id === this.selectedShopifyStore);
    return selectedStore?.Id || '';
  }

  private getSquareSpaceAccountId(): string {
    const selectedStore = this.squareSpaceStoreDetails.find(store => store.Id === this.siteId);
    return selectedStore?.Id || '';
  }



  public acceptConsignmentProductsDialog(platform: 'Square' | 'Shopify' | 'WooCommerce' | 'Wix' | 'SquareSpace', isChecked: boolean): void {
    if (platform === 'WooCommerce' && isChecked) {
      this.selectedPlatformDailaog = true;
      this.getWoocommerceAccountDetail();
      this.isWooCommercePlatform = true;
      console.log("WooCommerce dialog opened");
    } else if (platform === 'Shopify' && isChecked) {
      this.isShopifyStoreDialogVisible = true;
      this.getShopifyAccountDetails();
      this.isShopifyPlatform = true;
      console.log("Shopify dialog opened");
    } else if (platform === 'SquareSpace' && isChecked) {
      this.isSquareSpaceStoreDialogVisible = true;
      this.getSquareSpaceAccountDetails();
      this.isSquareSpacePlatform = true
    }
  }

  public getSquareSpaceAccountDetails() {
    this.ngxSpinnerService.show();
    this.squareSpaceService.getSquareSpaceAccountDetails().subscribe((response: any) => {
      if (response) {
        this.squareSpaceStoreDetails = response;
        // If only one store, automatically select it
        if (this.squareSpaceStoreDetails.length === 1) {
          this.siteId = this.squareSpaceStoreDetails[0].Id;
          this.getSitePages(this.siteId);
        }
        this.ngxSpinnerService.hide();
      }
    }, (error) => {
      this.ngxSpinnerService.hide();
      console.error('Error fetching SquareSpace account details:', error);
    });
  }

  private getSitePages(id: string) {
    this.squareSpaceService.getSquareSpaceStorePages(id).subscribe((response: any) => {
      if (response.Success) {
        this.squareSpaceStorePage = response.ResponseData.storePages
      }
    })
  }


  public confirmSquareSpaceSelection(): void {
    if (this.pageId && this.siteId) {
      this.isSquareSpaceStoreDialogVisible = false;
      this.handlePlatformSelection('SquareSpace', true);
    }
  }

  public onCloseSquareSpaceDialog(): void {
    this.isSquareSpaceStoreDialogVisible = false;
    this.resetSquareSpaceSelection();
    this.selectAllState['SquareSpace'] = false;
  }

  public selectSquareSpaceSiteChange(event: any): void {
    this.siteId = event.value;
    console.log('Selected SquareSpace Site ID:', this.siteId);
    this.pageId = '';
    this.getSitePages(event.value);
  }

  public selectdSquareSpacePageChange(event: any): void {
    this.pageId = event.value;
    console.log('Selected SquareSpace Page ID:', this.pageId);
  }

  public getWoocommerceAccountDetail() {
    this.isLoading = false;
    this.ngxSpinnerService.show();
    this.wooCommerceService.getWoocommerceAccountDetails(false).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response) {
          this.wooCommerceAccountList = response;
          this.isLoading = true;
        }
      },
      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Error fetching Woocommerce account details:', error);
      }
    );
  }

  public onWoocommerceStoreChange(event: any): void {
    this.selectedWoocommerceStore = event.value;
    console.log('Selected WooCommerce Store ID:', this.selectedWoocommerceStore);

    const selectedStore = this.wooCommerceAccountList.find(store => store.Id === this.selectedWoocommerceStore);
    if (selectedStore) {
      // Update platformsToSend with selected store
      this.platformsToSend = [...this.platformsToSend.filter(p => p.plateform !== 'woocommerce'), {
        plateform: 'woocommerce',
        accountId: this.selectedWoocommerceStore
      }];
      console.log("Updated platformsToSend:", this.platformsToSend);

      // Close the dialog and mark WooCommerce as selected
      this.selectedPlatformDailaog = false;
      this.handlePlatformSelection('WooCommerce', true);
    }
  }

  public onShopifyStoreChange(event: any): void {
    this.selectedShopifyStore = event.value;
    console.log('Selected Shopify Store ID:', this.selectedShopifyStore);

    const selectedStore = this.shopifyAccountList.find(store => store.Id === this.selectedShopifyStore);
    if (selectedStore) {
      // Update platformsToSend with selected store
      this.platformsToSend = [
        ...this.platformsToSend.filter(p => p.plateform !== 'shopify'),
        {
          plateform: 'shopify',
          accountId: this.selectedShopifyStore
        }
      ];
      console.log("Updated platformsToSend:", this.platformsToSend);

      // Close the dialog and mark Shopify as selected
      this.isShopifyStoreDialogVisible = false;
      this.handlePlatformSelection('Shopify', true);
    }
  }

  public getShopifyAccountDetails() {
    this.isLoading = false;
    this.ngxSpinnerService.show();
    this.shopifyService.getShopifyAccounts().subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response) {
          this.shopifyAccountList = response;
          this.isLoading = true;
        }
      },
      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Error fetching Shopify account details:', error);
      }
    );
  }

  public onSyncArtworksClick(): void {
    if (this.selectedPlatform.length === 0) {
      console.log("No platforms selected for sync");
      return;
    }

    // Verify WooCommerce store is selected if WooCommerce is in selectedPlatform
    if (this.selectedPlatform.includes('WooCommerce') && !this.selectedWoocommerceStore) {
      console.log("WooCommerce selected but no store chosen");
      return;
    }

    // Verify Shopify store is selected if Shopify is in selectedPlatform
    if (this.selectedPlatform.includes('Shopify') && !this.selectedShopifyStore) {
      console.log("Shopify selected but no store chosen");
      return;
    }

    // Verify SquareSpace page is selected if SquareSpace is in selectedPlatform
    if (this.selectedPlatform.includes('SquareSpace') && !this.pageId) {
      console.log("SquareSpace selected but no page chosen");
      return;
    }

    // Open currency dialog for all selected platforms
    this.displayCurrencyDialog = true;
    this.prepareAndFetchExchangeRates(this.selectedPlatform);
    this.fetchExchangeRates();
  }

  onWooStoreDialogHide(): void {
    console.log('WooCommerce Store Dialog closed');
    if (!this.selectedWoocommerceStore) {
      this.resetWooCommerceSelection();
    }
  }



  onShopifyStoreDialogHide(): void {
    console.log('Shopify Store Dialog closed');
    if (!this.selectedShopifyStore) {
      this.resetShopifySelection();
    }
  }


  private resetWooCommerceSelection(): void {
    this.selectedWoocommerceStore = '';
    this.platformsToSend = this.platformsToSend.filter(p => p.plateform !== 'woocommerce');
    this.consignmentProducts.forEach(product => product.IsSyncToWooCommerce = false);

    if (this.selectedConsignmnetPoduct.productSyncRequests) {
      this.selectedConsignmnetPoduct.productSyncRequests.forEach(request => {
        request.IsSyncToWooCommerce = false;
      });
    }

    const index = this.selectedPlatform.indexOf('WooCommerce');
    if (index !== -1) {
      this.selectedPlatform.splice(index, 1);
    }

    this.selectAllState['WooCommerce'] = false;
    console.log('WooCommerce selection fully reset');
  }

  private resetShopifySelection(): void {
    this.selectedShopifyStore = '';
    this.platformsToSend = this.platformsToSend.filter(p => p.plateform !== 'shopify');
    this.consignmentProducts.forEach(product => product.IsSyncToShopify = false);

    if (this.selectedConsignmnetPoduct.productSyncRequests) {
      this.selectedConsignmnetPoduct.productSyncRequests.forEach(request => {
        request.IsSyncToShopify = false;
      });
    }

    const index = this.selectedPlatform.indexOf('Shopify');
    if (index !== -1) {
      this.selectedPlatform.splice(index, 1);
    }

    this.selectAllState['Shopify'] = false;
    console.log('Shopify selection fully reset');
  }

  private resetSquareSpaceSelection(): void {
    this.siteId = '';
    this.pageId = '';
    this.platformsToSend = this.platformsToSend.filter(p => p.plateform !== 'squarespace');
    this.consignmentProducts.forEach(product => product.IsSyncToSquareSpace = false);

    if (this.selectedConsignmnetPoduct.productSyncRequests) {
      this.selectedConsignmnetPoduct.productSyncRequests.forEach(request => {
        request.IsSyncToSquareSpace = false;
      });
    }

    if (this.selectedConsignmnetPoduct.squareSpaceAccountInfo) {
      this.selectedConsignmnetPoduct.squareSpaceAccountInfo = {
        id: '',
        pageId: ''
      };
    }

    const index = this.selectedPlatform.indexOf('SquareSpace');
    if (index !== -1) {
      this.selectedPlatform.splice(index, 1);
    }

    this.selectAllState['SquareSpace'] = false;
    console.log('SquareSpace selection fully reset');
  }

  public onCloseWooCommerceDialog(): void {
    this.selectedPlatformDailaog = false;
    this.resetWooCommerceSelection();
    this.selectAllState['WooCommerce'] = false;
  }

  public onCloseShopifyDialog(): void {
    this.isShopifyStoreDialogVisible = false;
    this.resetShopifySelection();
    this.selectAllState['Shopify'] = false;
  }
  public ishavelimt: boolean = false;
  public limit: number = 0;
  public displayUpgreadAccountDialog: boolean = false;
  public selectedShopifyStore: string = '';
  public shopifyAccountList: ShopifyStoreAccount[] = [];
  public isShopifyStoreDialogVisible: boolean = false;
  public isShopifyPlatform: boolean = false;

  public onUpgradeAccount() {
    this.isStripeDisplayPlansDialogVisible = true;
  }


  public connectWithSquareSpaceAccount() {
    this.Router.navigate(['/connect-with-squarespace-account']);
  }


  
     // Properties for product dialog
  public showProductDialog = false;
  public productId: string | null = null;
  // Handle toggle mode change

      // Open product dialog with specified product ID
  openProductDialog(productId: string) {
    this.productId = productId;
    this.showProductDialog = true;
  }
   // Close product dialog and reset product ID
  closeProductDialog() {
    this.showProductDialog = false;
    this.productId = null;
  }
}

